// CH-W41 Manage Session — heuristik ringan parse User-Agent -> { browser, os }.
// Display-only; tak perlu library. Null/kosong -> "Perangkat tidak dikenal".
export function parseUserAgent(ua) {
   if (!ua || typeof ua !== "string") {
      return { browser: "Perangkat tidak dikenal", os: "" };
   }

   let os = "Unknown OS";
   if (/windows nt/i.test(ua)) os = "Windows";
   else if (/iphone|ipad|ipod/i.test(ua)) os = "iOS";
   else if (/android/i.test(ua)) os = "Android";
   else if (/mac os x/i.test(ua)) os = "macOS";
   else if (/linux/i.test(ua)) os = "Linux";

   // Urutan penting: Edge/Opera/Brave menyertakan "Chrome"/"Safari" di UA-nya.
   let browser = "Browser";
   if (/edg\//i.test(ua)) browser = "Edge";
   else if (/opr\/|opera/i.test(ua)) browser = "Opera";
   else if (/brave/i.test(ua)) browser = "Brave";
   else if (/firefox\//i.test(ua)) browser = "Firefox";
   else if (/chrome\//i.test(ua)) browser = "Chrome";
   else if (/safari\//i.test(ua)) browser = "Safari";

   return { browser, os };
}
